import React from 'react';
type SectionHeadingProps = {
  eyebrow: string;
  title: React.ReactNode;
  description?: string;
  centered?: boolean;
};
export function SectionHeading({
  eyebrow,
  title,
  description,
  centered = false
}: SectionHeadingProps) {
  return <div className={centered ? 'mx-auto max-w-3xl text-center' : 'max-w-3xl'} data-id="element-154">
      <p className="mb-5 font-mono text-[10px] font-semibold uppercase tracking-[0.22em] text-gold" data-id="element-155">
        {eyebrow}
      </p>
      <h2 className="font-display text-4xl font-bold leading-[0.98] tracking-[-0.04em] text-ivory sm:text-5xl lg:text-6xl" data-id="element-156">
        {title}
      </h2>
      {description ? <p className={`mt-5 text-base leading-7 text-sage sm:text-lg ${centered ? 'mx-auto max-w-2xl' : 'max-w-2xl'}`} data-id="element-157">
          {description}
        </p> : null}
    </div>;
}